import Highcharts from 'highcharts';

export default class InfoGraphicChart {
  constructor( node, data ) {
    this.node = node;
    this.options = data;
    this.colors = {
      multi: [ '#FFD904', '#C8ED10', '#A4C20F', '#0096C1', '#00C6FF', '#CCDBEA', '#2586E6', '#004B95' ],
      default: [ '#004B95', '#2586E6', '#CCDBEA', '#00C6FF', '#0096C1', '#B2DFEC', '#7FA5CA', '#92C2F2' ]
    };
    this.language = document.documentElement.lang;

    this.addInnerContainers();
    this.setOptions();
    this.render();
  }

  render() {
    // for debugging
    this.node.classList.add( 'content-width' );
    this.node.classList.add( 'charts-highchart--' + this.options.chart.type );
    this.chart = Highcharts.chart( this.container, this.options );
  }

  addInnerContainers() {
    this.innerDiv = document.createElement( 'DIV' );
    this.innerDiv.classList.add( 'charts-highchart__inner' );
    this.container = document.createElement( 'DIV' );
    this.container.classList.add( 'charts-highchart__container' );
    this.innerDiv.appendChild( this.container );
    this.node.appendChild( this.innerDiv );
  }

  setOptions() {
    this.options.multiColor = this.node.classList.contains( 'charts-multicolor' );

    this.mergeObjects( this.options, {
      chart: {
        style: {}
      },
      colors: this.options.multiColor ? this.colors.multi : this.colors.default,
      legend: {
        enabled: false
      },
      tooltip: {
        backgroundColor: 'transparent',
        borderWidth: 0,
        padding: 0,
        shadow: false,
        useHTML: true,
        formatter: function() {
          return `
            <div class="charts-highchart__tooltip">
                <span>${this.series.chart.userOptions.yAxis[ 0 ].title.text}</span>
                <br>
                <strong>${ this.y }</strong>
                <svg class="charts-highchart__tooltip-arrow" width="16" height="16" viewBox="0 0 100 100">
                    <polygon fill="white" points="0 0 100 0 50 65"></polygon>
                </svg>
            </div>
            `;
        }
      },
      plotOptions: {
        series: {
          dataLabels: {
            style: {
              textOutline: 0
            }
          }
        }
      }
    });
    if ( /iP(hone|od|ad)/.test( navigator.platform )) {
      const v = ( navigator.appVersion ).match( /OS (\d+)_(\d+)_?(\d+)?/ );
      let ver = [ parseInt( v[ 1 ], 10 ), parseInt( v[ 2 ], 10 ), parseInt( v[ 3 ] || 0, 10 ) ];
      if ( ver[ 0 ] > 10 ) {
        this.options.chart.style = {};
        this.options.chart.style.fontFamily = 'TheSansC5-5';
      }
    } else {
      this.options.chart.style = {};
      this.options.chart.style.fontFamily = 'TheSansC5-5';
    }
    this.setFirstYAxis();
    if ( this.options.yAxis[ 1 ]) {
      this.setSecondYAxis();
    }
  }

  setFirstYAxis() {
    // Allow Highcharts to use the default formatter for y-axis labels.
    let suffix = this.options.yAxis[ 0 ].labels.suffix;
    let prefix = this.options.yAxis[ 0 ].labels.prefix;
    this.options.yAxis[ 0 ].labels = {
      formatter: function() {
        return prefix + this.axis.defaultLabelFormatter.call( this ) + suffix;
      }
    };
    this.options.yAxis[ 0 ].endOnTick = true;
  }

  setSecondYAxis() {
    let suffix1 = this.options.yAxis[ 1 ].labels.suffix;
    let prefix1 = this.options.yAxis[ 1 ].labels.prefix;
    this.options.yAxis[ 1 ].labels = {
      formatter: function() {
        return prefix1 + this.axis.defaultLabelFormatter.call( this ) + suffix1;
      }
    };
    this.options.yAxis[ 0 ].endOnTick = true;
    this.options.series[ 1 ].yAxis = 1;
  }

  /**
   * use instead of Object.assign() to merge
   * obj2 into obj1 and consider nested objects
   * @param obj1
   * @param obj2
   */
  mergeObjects( obj1, obj2 ) {
    Object.keys( obj2 ).forEach(( key ) => {
      let property = obj2[ key ];
      if ( this.isEmptyObject( property )) {
        return;
      }
      if ( Object.keys( obj2[ key ]).length > 0 && typeof property !== 'string' && obj1[ key ] && !Array.isArray( property )) {
        this.mergeObjects( obj1[ key ], property );
      } else {
        obj1[ key ] = obj2[ key ];
      }
    });
  }
  // https://stackoverflow.com/a/32108184
  isEmptyObject( obj ) {
    return Object.keys( obj ).length === 0 && obj.constructor === Object;
  }
}
